import { authenticationConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case authenticationConstants.ORGANIZATION_LOGO_REQUEST:
      return {
        data: null,
        isProgress: true,
      };
    case authenticationConstants.ORGANIZATION_LOGO_SUCCESS: {
      const result = action.response.data;
      return {
        data: result,
        isProgress: false,
      };
    }
    case authenticationConstants.ORGANIZATION_LOGO_FAILURE:
      return {
        data: null,
        error: action.error,
        isProgress: false,
      };
    default:
      return state;
  }
}
